/**
 * Auth API client — talks to /api/auth/*
 * All requests include credentials so cookies (access_token, refresh_token,
 * session_token) flow on every call.
 */
const API = process.env.REACT_APP_BACKEND_URL;

async function call(path, options = {}) {
  const res = await fetch(`${API}/api/auth${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options,
  });
  if (!res.ok) {
    let detail = `Request failed (${res.status})`;
    try {
      const body = await res.json();
      detail = formatDetail(body.detail) || detail;
    } catch (parseErr) {
      // Response body wasn't JSON (e.g. 502 HTML proxy error) — keep the
      // status-code fallback and surface the parse issue at debug level.
      if (typeof console !== "undefined") {
        console.debug("auth.call: non-JSON error response", parseErr);
      }
    }
    throw new Error(detail);
  }
  if (res.status === 204) return null;
  return res.json();
}

function formatDetail(d) {
  if (d == null) return null;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) {
    return d.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).join(' ');
  }
  if (d && typeof d.msg === 'string') return d.msg;
  return String(d);
}

export const authApi = {
  me: () => call('/me'),
  bootstrap: () => call('/bootstrap'),
  login: (email, password) => call('/login', { method: 'POST', body: JSON.stringify({ email, password }) }),
  register: (email, password, name, persona) =>
    call('/register', { method: 'POST', body: JSON.stringify({ email, password, name, persona }) }),
  updatePersona: (persona) =>
    call('/persona', { method: 'POST', body: JSON.stringify({ persona }) }),
  logout: () => call('/logout', { method: 'POST' }),
  refresh: () => call('/refresh', { method: 'POST' }),
  forgotPassword: (email) => call('/forgot-password', { method: 'POST', body: JSON.stringify({ email }) }),
  resetPassword: (token, newPassword) =>
    call('/reset-password', { method: 'POST', body: JSON.stringify({ token, new_password: newPassword }) }),
  googleSession: (sessionId) =>
    call('/google/session', { method: 'POST', body: JSON.stringify({ session_id: sessionId }) }),
};
